'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Field = require('./Field');

var _Field2 = _interopRequireDefault(_Field);

var _styled = require('./styled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Select = function Select(_ref) {
  var value = _ref.value,
      placeholder = _ref.placeholder,
      _onChange = _ref.onChange,
      children = _ref.children,
      options = _ref.options,
      selectProps = _ref.selectProps,
      error = _ref.error,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ['value', 'placeholder', 'onChange', 'children', 'options', 'selectProps', 'error', 'disabled']);

  return _react2.default.createElement(
    _Field2.default,
    _extends({ error: error }, rest),
    _react2.default.createElement(
      _styled.Select,
      _extends({
        value: value,
        placeholder: placeholder,
        error: error,
        onChange: function onChange(e) {
          if (!placeholder || e.target.value !== placeholder) {
            _onChange(e);
          }
        },
        disabled: disabled
      }, selectProps),
      placeholder && _react2.default.createElement(
        'option',
        { className: 'placeholder', disabled: true },
        placeholder
      ),
      children
    ),
    _react2.default.createElement(_styled.DownTriangle, null)
  );
};

Select.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, _Field2.default.propTypes, {
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  selectProps: _propTypes2.default.object
}) : {};

Select.defaultProps = {
  selectProps: {}
};

Select.displayName = 'Field.Select';

exports.default = Select;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/Field/Select.js
// module id = 686
// module chunks = 14